export default __webpack_public_path__ + "static/media/6.7bbe63a9.jpg";